import { render, staticRenderFns } from "./GroupTypeCustomFields.vue?vue&type=template&id=e20163b0&scoped=true&"
import script from "./GroupTypeCustomFields.vue?vue&type=script&lang=js&"
export * from "./GroupTypeCustomFields.vue?vue&type=script&lang=js&"
import style0 from "./GroupTypeCustomFields.vue?vue&type=style&index=0&id=e20163b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20163b0",
  null
  
)

export default component.exports